<template>
  <div class="home_container">
    <!-- 背景图（中间区域） -->
    <img v-if="isMobile==0" :src="'https://app.choisiyachts.com'+config.home_cover_image" class="home_img"/>
    <img v-if="isMobile==1" :src="'https://app.choisiyachts.com'+config.home_cover_image_mobile" class="home_img"/>

    <!-- 底部组件（固定在底部） -->
    <bottom class="bottom-component"></bottom>
  </div>
</template>

<script>
import { proCategories, proList,getConfig } from '../../request/api.js'
import bottom from './bottom.vue';

export default {
  name: 'Home',
  components: {
    bottom
  },
  data() {
    return {
      config:null,
      isMobile: 0
    }
  },
  mounted() {
    this.isMobile=localStorage.getItem('isMobile')
    getConfig().then(res => {
      this.config = res.data.data
    })
  }
}
</script>

<style>
.home_container {
  display: flex;
  justify-content: space-between;
  flex-direction: column;
  width: 100%;
  padding-bottom: 0;
  min-height: calc(100vh - 120px);
  overflow: hidden;
  background: #0a1628;
}

/* 背景图铺满中间区域，避免笔记本上出现灰白空带 */
.home_img {
  flex: 1;
  width: 100%;
  max-width: 100%;
  min-height: 560px;
  height: auto;
  object-fit: cover;
  object-position: center;
  display: block;
  opacity: 0;
  transform: scale(0);
  animation: fadeInFromCenter 1.2s forwards;
}

/* 底部组件：固定在底部 */
.bottom-component {
  width: 100%;
  z-index: 10;
  flex-shrink: 0;
}

/* 从里到外出现的动画 */
@keyframes fadeInFromCenter {
  0% {
    opacity: 0;
    transform: scale(0);
  }
  100% {
    opacity: 1;
    transform: scale(1);
  }
}
</style>